import { render, staticRenderFns } from "./ExchangeProcessAmount.vue?vue&type=template&id=625e2c3e&"
import script from "./ExchangeProcessAmount.vue?vue&type=script&lang=ts&"
export * from "./ExchangeProcessAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports